<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="cguStore">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody">
                            <img
                                v-if="getCguStatus"
                                src="../../assets/croix.png"
                                width="20"
                                height="20"
                                alt
                                @click="close"
                                class="cross fright abs pointer"
                            />
                            <div class="modalContent">
                                <loader :loading="loader"></loader>
                                <h2 class="title">{{ $t("cguModal.title") }}</h2>
                                <p class="cguContent" v-html-safe="cguContent[$t('trad')].value"></p>
                                <div class="buttonChoices txtRight" v-if="!getCguStatus">
                                    <button @click="acceptCgu" class="btn btn-exp">{{ $t("cguModal.acceptButton") }}</button>
                                    <button @click="refuseCgu" class="btn btn-exp">{{ $t("cguModal.refuseButton") }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import Vue from "vue";
import httpService from "../../components/service";
import Toast from "vue-easy-toast";
import { mapActions, mapGetters } from "vuex";
import loader from "../loader/loader";
import { clearLocalStorage } from "@/utils/storage";

Vue.use(Toast);

export default {
    data: () => ({
        cguContent: null,
        loader: true
    }),
    name: "Cgumodal",
    components: {
        loader
    },
    directives: {},
    computed: {
        ...mapGetters("cguStore", {
            getCguStatus: "getCguStatus",
            getShown: "getShown"
        })
    },
    methods: {
        ...mapActions("cguStore", {
            setCguStatus: "setCguStatus",
            setShown: "setShown"
        }),
        refuseCgu() {
            httpService.post("/logout", JSON.stringify({})).then(response => {
                clearLocalStorage();
                this.$router.go("/");
            });
        },
        acceptCgu() {
            httpService
                .put("/profile/accept-cgu", JSON.stringify({}))
                .then(response => {
                    this.$router.go();
                    this.setCguStatus(true);
                    this.setShown(false);
                })
                .catch(errors => {});
        },
        close() {
            this.setShown(false);
        }
    },
    created() {
        let baseUrl = location.protocol + "//" + process.env.SUFFIX_URL;
        httpService
            .fetch("GET", baseUrl + "/cgu/last", null, false, true)
            .then(response => {
                this.cguContent = response.terms.content;
                this.loader = false;
            })
            .catch(errors => {});
    }
};
</script>

<style lang="scss" scoped>
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}

/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: -10px;
        right: -10px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            position: relative;
            background: #fff;
            width: 70%;
            height: 600px;
            border-radius: 4px;
            margin: auto;
            .modalContent {
                text-transform: none;
                padding: 10px;
                .title {
                    font-family: Oswald;
                    font-weight: normal;
                    font-size: 30px;
                }
                .cguContent {
                    font-size: 16px;
                    padding: 10px;
                    border: 1px #eee solid;
                    max-height: 400px;
                    overflow: auto;
                }
                .buttonChoices {
                    button {
                        margin: 0px 10px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// CguModal.vue?2794d258